import { connect } from 'react-redux';
import ElectionOverview from 'components/currentBallots/ElectionOverview';

const mapStateToProps = ({ ballots }) => ({
  hasCurrentBallot: ballots.currentBallots.length > 0,
  currentBallots: ballots.currentBallots,
});

export default connect(mapStateToProps, null)(ElectionOverview);
